module.exports = __webpack_public_path__ + "img/dice-two.81355d61.svg";